import { PageNotfoundComponent } from './page-notfound/page-notfound.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PoModule } from '@po-ui/ng-components';

@NgModule({
  imports: [CommonModule, PoModule],
  declarations: [PageNotfoundComponent]
})
export class ErrorsModule { }
